// frontend/src/features/equipment/EquipmentSetupWizard/components/QuantityPrompt.tsx
import { Alert, Radio, Text, Stack } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

interface QuantityPromptProps {
  modelName: string;
  quantity: number;
  trackSeparately: boolean;
  onTrackSeparatelyChange: (value: boolean) => void;
}

export function QuantityPrompt({
  modelName,
  quantity,
  trackSeparately,
  onTrackSeparatelyChange,
}: QuantityPromptProps) {
  // Only show when quantity > 1
  if (quantity <= 1) {
    return null;
  }

  const displayName = modelName || 'items';
  const pluralizedName = `${displayName}s`;

  const handleChange = (value: string) => {
    onTrackSeparatelyChange(value === 'separate');
  };

  return (
    <Alert
      icon={<IconInfoCircle size={16} />}
      color="blue"
      variant="light"
      mt="sm"
    >
      <Stack gap="sm">
        <Text size="sm" fw={500}>
          You're adding {quantity} {pluralizedName}.
        </Text>
        <Radio.Group
          value={trackSeparately ? 'separate' : 'same'}
          onChange={handleChange}
        >
          <Stack gap="xs">
            <Radio
              value="same"
              label="Same install date / serial numbers don't matter"
            />
            <Radio
              value="separate"
              label="Different dates or serials - I'll add details separately"
            />
          </Stack>
        </Radio.Group>
      </Stack>
    </Alert>
  );
}
